import { useEffect, useState } from "react";

import axios from "axios";

import schema from "./schema";
import { DOMAIN } from "config/config";

import Formizo from "Components/LabIZO/Formizo";
import { Accessor, Env, ErrorX, store, ColorX } from "static";
import { VStack, HStack, Spacer } from "Components/LabIZO/Stackizo";
import { backendConnector, DATA_LINK } from "connectors";
import _ from "lodash";

const GPTSettings = () => {
  const [gptInfo, setGptInfo] = useState(null);
  const [intents, setIntents] = useState<{ _id: string; caption: string }[]>([]);

  const getQuickReplies = async () => {
    try {
      let payload = {
        data: {
          skip: 0,
          limit: 9999,
          fields: ["_id"],
        },
        addOns: {
          workspace: "ALL",
          allIntents: true,
        },
      };

      let rtn = await backendConnector.post(DATA_LINK.IntentList, payload.data, payload.addOns);
      console.log("/Tables/Intent/List", rtn);

      let docs = rtn.payload.docs;
      let intents = _.map(docs, (o, i) => {
        let [workspace, alias] = o._id.split(":");

        return {
          _id: `CMD_BTN ${alias}`,
          caption: alias as string,
        };
      });

      intents = _.filter(intents, (o) => o._id !== "");
      intents = [...intents];
      console.log(intents);

      setIntents(intents);
    } catch (e: any) {
      ErrorX.Handle(e);
    }
  };

  const getGptConfig = async () => {
    try {
      const data = await backendConnector.post(DATA_LINK.SYSGPTConfig);
      setGptInfo(data.payload);
    } catch (e: any) {
      ErrorX.Handle(e);
    }
  };
  useEffect(() => {
    getGptConfig();
  }, []);

  useEffect(() => {
    getQuickReplies();
  }, []);

  const onSubmit = async (data: any) => {
    let link = "/Config/GPTSystem/Edit";
    let url = DOMAIN + link;
    let payloadOut = {
      data: {
        ...data,
      },
      JWT: store.user.JWT,
    };

    try {
      console.log(link, payloadOut);

      store.isLoading(true);
      let { data } = await axios.post(url, payloadOut);
      store.isLoading(false);
      console.log(link, data);
      if (!data.Success) {
        ErrorX.Handle(data.payload);
        return;
      }

      //updon success
      store.Alert("System GPTConfig updated successfully", "success");
      await Env.GetSysInfo();
    } catch (e) {
      store.Alert("Cannot set system GPTconfig", "error");
    }
  };

  const renderGPTSetting = () => {
    return (
      <Formizo
        //
        schema={schema.gptConig}
        buttons={["Revert", "Submit"]}
        defaultValue={gptInfo}
        onSubmit={onSubmit}
        addOns={{
          intents: intents,
        }}
      />
    );
  };
  return (
    <HStack justifyContent="flex-start" height="100%" gap={3} paddingX={4}>
      <VStack width="100%">{renderGPTSetting()}</VStack>
    </HStack>
  );
};
export default GPTSettings;
